'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_crud$PageViewParts(view, execButton) {
  this.KF = null;
  this.KE = null;
  this.KF = view;
  this.KE = execButton;
}
export { $c_Lpresto_crud$PageViewParts as $c_Lpresto_crud$PageViewParts };
$p = $c_Lpresto_crud$PageViewParts.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_crud$PageViewParts;
/** @constructor */
function $h_Lpresto_crud$PageViewParts() {
}
export { $h_Lpresto_crud$PageViewParts as $h_Lpresto_crud$PageViewParts };
$h_Lpresto_crud$PageViewParts.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_crud$PageViewParts)) {
    var x = this.KF;
    var x$2 = x$0.KF;
    if ((x === x$2)) {
      var x$3 = this.KE;
      var x$4 = x$0.KE;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "PageViewParts";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.KF;
  }
  if ((n === 1)) {
    return this.KE;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_crud$PageViewParts(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jk)));
}
export { $isArrayOf_Lpresto_crud$PageViewParts as $isArrayOf_Lpresto_crud$PageViewParts };
var $d_Lpresto_crud$PageViewParts = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_crud$PageViewParts, "presto.crud$PageViewParts", ({
  jk: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_crud$PageViewParts as $d_Lpresto_crud$PageViewParts };
//# sourceMappingURL=presto.crud$-Page-View-Parts.js.map
